/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
import { createUseGlobalVariants } from "@plasmicapp/react-web";
import { useScreenVariants as useScreenVariantspwcOBwMYcrFs } from "../o_21_p_0_0_2_prod/PlasmicGlobalVariant__Screen"; // plasmic-import: pwcOBwMYcrFs/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantspwcOBwMYcrFs
});
